/* ═══════════════════════════════════════════════════════════
   LAZPLAY — SHOWCASE WORLDS & PROJECTS DATA
   One dedicated project per planetary destination
   ═══════════════════════════════════════════════════════════ */

export const showcaseProjects = [
  {
    id: 'waymaker',
    index: '01',
    worldName: 'Aethelgard (Habitable World)',
    worldType: 'earth',
    name: 'Waymaker',
    badge: 'FEATURED GAME',
    tagline: 'Run through infinite procedurally evolving worlds that defy physics.',
    category: 'Infinite Runner · Spatial Action',
    creator: 'Nova Studios',
    creatorLocation: 'Bangalore, IN',
    description:
      'Waymaker is a high-octane spatial endless runner featuring dynamic gravity shifts, adaptive procedural terrain generation, and an electric orchestral soundtrack that reacts in real-time to your momentum.',
    specs: [
      { label: 'ENGINE', value: 'Custom C++ / WebGPU' },
      { label: 'PLAYERS', value: '245K Active' },
      { label: 'RATING', value: '4.9 ★★★★★' },
      { label: 'SIZE', value: '180 MB' }
    ],
    platforms: ['Windows', 'macOS', 'VisionOS', 'Web'],
    themeColor: '#43DDD0',
    planetColor: '#2563eb',
    atmosphereColor: '#60a5fa',
    actionText: 'PLAY WAYMAKER DEMO →',
    // High-fidelity conceptual artwork URLs
    image: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=1200&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=600&q=80'
    ]
  },
  {
    id: 'pulse-engine',
    index: '02',
    worldName: 'Ares Prime (Desert Foundry)',
    worldType: 'mars',
    name: 'Pulse Engine',
    badge: 'CREATOR SOFTWARE',
    tagline: 'The ultra-lightweight game runtime engineered for spatial computing.',
    category: 'Game Engine · Developer Suite',
    creator: 'Pulse Labs',
    creatorLocation: 'Hyderabad, IN',
    description:
      'A blazing fast 60fps+ 2D/3D development environment written in Rust. Instant live hot-reloading, built-in spatial audio synthesizer, and zero-overhead physics simulation out of the box.',
    specs: [
      { label: 'RUNTIME', value: 'Rust & WebAssembly' },
      { label: 'FOOTPRINT', value: '< 12 MB' },
      { label: 'BENCHMARK', value: '120 FPS at 4K' },
      { label: 'LICENSE', value: 'MIT Open Source' }
    ],
    platforms: ['Windows', 'macOS', 'Linux', 'WebAssembly'],
    themeColor: '#f97316',
    planetColor: '#c2410c',
    atmosphereColor: '#fb923c',
    actionText: 'DOWNLOAD PULSE RUNTIME →',
    image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=1200&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=600&q=80'
    ]
  },
  {
    id: 'celestial-drift',
    index: '03',
    worldName: 'Chronos (Ringed Gas Giant)',
    worldType: 'jupiter',
    name: 'Celestial Drift',
    badge: 'MULTIPLAYER UNIVERSE',
    tagline: 'Explore an infinite synchronized galaxy with thousands of space explorers.',
    category: 'Space Exploration · MMO Sandbox',
    creator: 'Starfield Interactive',
    creatorLocation: 'Mumbai, IN',
    description:
      'Seamless interplanetary travel with zero loading screens. Build orbital stations, mine rich asteroid belts, customize hyperdrive cruisers, and trade rare minerals across uncharted star clusters.',
    specs: [
      { label: 'UNIVERSE', value: '10,000+ Star Systems' },
      { label: 'CONCURRENT', value: '512K Pilots' },
      { label: 'NETWORKING', value: 'Tickless P2P WebRTC' },
      { label: 'COMMUNITY', value: '98% Positive' }
    ],
    platforms: ['Windows', 'macOS', 'Steam Deck', 'Cloud'],
    themeColor: '#eab308',
    planetColor: '#ca8a04',
    atmosphereColor: '#fef08a',
    actionText: 'BOARD THE EXPEDITION →',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1200&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1506703719100-a0f3a48c0f86?auto=format&fit=crop&w=600&q=80'
    ]
  },
  {
    id: 'formcraft',
    index: '04',
    worldName: 'Glacies (Ice Crystal Giant)',
    worldType: 'neptune',
    name: 'FormCraft Studio',
    badge: 'DESIGN SYSTEM SOFTWARE',
    tagline: 'Design 3D spatial user interfaces with liquid glass aesthetics.',
    category: 'Spatial UI · Creative Tool',
    creator: 'PixelForge Studio',
    creatorLocation: 'Chennai, IN',
    description:
      'The modern design tool built specifically for volumetric and liquid glass computing interfaces. Directly export to React Three Fiber, Swift Spatial UI, and Unity shaders with real-time refraction preview.',
    specs: [
      { label: 'RENDERER', value: 'Realtime Raymarching' },
      { label: 'EXPORTS', value: 'R3F / Swift / USDZ' },
      { label: 'DESIGNERS', value: '150K+' },
      { label: 'PRESETS', value: '500+ Liquid Glass' }
    ],
    platforms: ['macOS', 'Windows', 'Web Browser', 'VisionOS'],
    themeColor: '#38bdf8',
    planetColor: '#0284c7',
    atmosphereColor: '#7dd3fc',
    actionText: 'LAUNCH FORMCRAFT IN BROWSER →',
    image: 'https://images.unsplash.com/photo-1634017839464-5c339ebe3cb4?auto=format&fit=crop&w=1200&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1581291518655-9523c932edcf?auto=format&fit=crop&w=600&q=80'
    ]
  },
  {
    id: 'ember-chronicles',
    index: '05',
    worldName: 'Ignis (Volcanic Core)',
    worldType: 'volcanic',
    name: 'Ember Chronicles',
    badge: 'INDIE HIGHLIGHT',
    tagline: 'A hand-drawn platformer forged in fire, courage, and ancient secrets.',
    category: 'Story Platformer · Metroidvania',
    creator: 'Blaze Interactive',
    creatorLocation: 'Pune, IN',
    description:
      'Guide a flame-wielder spirit through crumbling volcanic ruins. Master precise acrobatic jumps, unlock thermal dash abilities, and solve intricate environmental puzzles surrounded by gorgeous particle embers.',
    specs: [
      { label: 'ANIMATION', value: 'Hand-Drawn 60fps' },
      { label: 'STORY', value: '14 Deep Chapters' },
      { label: 'SOUNDTRACK', value: '28 Original Scores' },
      { label: 'AWARDS', value: 'Best Art Direction' }
    ],
    platforms: ['Windows', 'Nintendo Switch', 'macOS'],
    themeColor: '#ef4444',
    planetColor: '#991b1b',
    atmosphereColor: '#f87171',
    actionText: 'EXPLORE EMBER CHRONICLES →',
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=1200&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1579783902614-a3fb3927b675?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=600&q=80'
    ]
  },
  {
    id: 'code-forge',
    index: '06',
    worldName: 'Nexus Zero (Cybernetic Sphere)',
    worldType: 'cyber',
    name: 'Code Forge AI',
    badge: 'DEVELOPER SUITE',
    tagline: 'The AI-native terminal and IDE built for developer flow state.',
    category: 'Developer Environment · AI Tool',
    creator: 'DevCraft Labs',
    creatorLocation: 'Bengaluru, IN',
    description:
      'Autonomous debugging, instant multi-file code transformations, and an integrated local neural reasoning engine. Code Forge turns complex system engineering into an effortless creative flow.',
    specs: [
      { label: 'SPEED', value: '< 2ms Key Latency' },
      { label: 'MODELS', value: 'Local + Cloud LLMs' },
      { label: 'EXTENSIONS', value: 'VSCode Compatible' },
      { label: 'SECURITY', value: 'Air-gapped Ready' }
    ],
    platforms: ['macOS', 'Linux', 'Windows'],
    themeColor: '#a855f7',
    planetColor: '#3b0764',
    atmosphereColor: '#c084fc',
    actionText: 'INSTALL CODE FORGE →',
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1200&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=600&q=80'
    ]
  }
];

export const sectionsList = [
  { id: 'intro', name: 'DEEP SPACE', start: 0, end: 0.12 },
  { id: 'waymaker', name: 'WAYMAKER', start: 0.12, end: 0.26 },
  { id: 'pulse-engine', name: 'PULSE ENGINE', start: 0.26, end: 0.40 },
  { id: 'celestial-drift', name: 'CELESTIAL DRIFT', start: 0.40, end: 0.54 },
  { id: 'formcraft', name: 'FORMCRAFT', start: 0.54, end: 0.68 },
  { id: 'ember-chronicles', name: 'EMBER CHRONICLES', start: 0.68, end: 0.82 },
  { id: 'code-forge', name: 'CODE FORGE', start: 0.82, end: 0.94 },
  { id: 'gateway', name: 'SOLAR GATEWAY', start: 0.94, end: 1.0 }
];
